import { DataSourceIcon } from '@/lib';
import { DataSource, DataSourceCodeConfig, EDataSourceCategory } from '@/models/dataSource';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

type AudienceDetailsSourcesProps = {
  datasources?: DataSource[];
};

export const AudienceDetailsSources: FC<AudienceDetailsSourcesProps> = ({ datasources }) => {
  const { t } = useTranslation();

  const dataSources = datasources || [];

  return (
    <div>
      <div className='mt-8 flex items-start justify-between gap-8 border-b border-secondary-border pb-10'>
        <div className='flex w-[280px] shrink-0 flex-col gap-2'>
          <h3 className='text-lg font-semibold text-secondary-700'>{t('audience_details:sources_and_rules.data_sources_title')}</h3>
          <p className='text-sm text-tertiary-600'>
            <Trans
              i18nKey={'audience_details:sources_and_rules.data_sources_subtitle'}
              components={{
                newLine: <br />,
              }}
            />
          </p>
        </div>

        <div className='min-w-0 flex-1'>
          {dataSources.map((dataSource) => (
            <div key={dataSource.id} className='flex items-center justify-between border-b border-secondary-border py-3'>
              <div className='flex min-w-0 flex-1 items-center'>
                {dataSource.type && (
                  <div className='mr-2 flex size-14 shrink-0 flex-wrap place-content-center rounded-lg'>
                    <DataSourceIcon type={dataSource.type.id} className='h-10' />
                  </div>
                )}
                <div className='flex min-w-0 flex-col'>
                  <p className='truncate font-medium text-primary-900'>{dataSource.name}</p>
                  {dataSource.type.category === EDataSourceCategory.CODE ? (
                    <p className='truncate text-sm font-normal text-gray-500'>
                      {`${dataSource.type.name} • ${(dataSource.configuration as DataSourceCodeConfig).url}`}{' '}
                    </p>
                  ) : (
                    <p className='truncate text-sm font-normal text-gray-500'>{`${dataSource.type.name}`} </p>
                  )}
                </div>
              </div>
              <NavLink to={`/data-sources/${dataSource.id}`} className='ml-4 shrink-0 whitespace-nowrap text-brand-600 hover:underline'>
                <p>{t('audience_details:sources_and_rules.go_to_source')}</p>
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
